module.exports = __webpack_public_path__ + "img/img1.ddc4140d.png";